// Sekce formuláře: nadpis s ikonou nad podbarveným blokem polí.
// Sdílené mezi dialogem pozvánky (Team.js) a úpravou člena (TeamMemberDetail.js).
export function FormSection({ icon: Icon, title, children }) {
  return (
    <div className="bg-secondary/60 border border-border rounded-[14px] p-4">
      <div className="flex items-center gap-2 mb-3">
        <Icon size={16} className="text-brand" />
        <span className="font-heading font-extrabold text-[12px] uppercase tracking-[0.07em]">{title}</span>
      </div>
      {children}
    </div>
  );
}
